import { TextButton } from "@/pages/child-customer/atom";
import { useGlobalStore } from "@/store/GlobalStore";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import styled from "styled-components";
import { ToolTip, ToolTipWrapper } from "../../atom";
import { useDeleteProject } from "../../hook/useDeleteProject";
import { useEditProject } from "../../hook/useEditProject";
import { Project } from "../../types";
import AddOrEditProjectModal from "../add-or-edit-project-drawer";
import { DeleteProjectModal } from "../delete-project-modal";
import { useStatus } from "./hooks/useStatus";

export function ProjectOperation(row: Project.Info) {
  const {
    open,
    dataSource,
    targetKeys,
    onSelectChange,
    onOpen,
    onStateChange,
    onEdit,
    projectForm,
    params,
    setParams,
    handleRemoveChange,
  } = useEditProject();
  const { projectId, status, projectName, users } = row;
  const { userInfo } = useGlobalStore();
  const t = getTranslateNsT("center");
  const { changeProjectStatus } = useStatus();
  const { openDeleteModal, setOpenDeleteModal, handleDelete } =
    useDeleteProject();
  const isCreator = userInfo?.userId === row.userId;
  const isOpenStatus = !Boolean(status);
  return (
    <OperationWrapper>
      <TextButton
        type="text"
        onClick={() => changeProjectStatus(projectId, status)}
      >
        {t(`user_com_childPro_head_label_operate_status_${Number(status)}`)}
      </TextButton>
      <TextButton type="text" onClick={() => setOpenDeleteModal(true)}>
        {t("user_com_childPro_render_del_btn")}
      </TextButton>
      <DeleteProjectModal
        open={openDeleteModal}
        projectName={projectName}
        modalProps={{
          onCancel: () => setOpenDeleteModal(false),
          onOk: () => handleDelete(projectName),
        }}
      />
      <ToolTipWrapper>
        {(!isCreator || !isOpenStatus) && (
          <ToolTip className="tool-tip">
            {!isOpenStatus
              ? t("user_com_childPro_not_edit_tip_1")
              : t("user_com_childPro_not_edit_tip_2")}
          </ToolTip>
        )}
        <TextButton
          className="button"
          disabled={!isOpenStatus || !isCreator}
          type="text"
          onClick={() => onOpen(projectName, users)}
        >
          {t("user_com_childPro_son_user_render_edit_member")}
        </TextButton>
      </ToolTipWrapper>

      <AddOrEditProjectModal
        operationType={Project.OperationType.EDIT}
        open={open}
        onOk={() => onEdit(row)}
        onCancel={() => onStateChange(false)}
        projectForm={projectForm}
        params={params}
        setParams={setParams}
        transferProps={{
          showSelectAll: false,
          dataSource,
          targetKeys,
          selectedKeys: [],
          onSelectChange,
          handleRemoveChange,
        }}
        row={row}
      />
    </OperationWrapper>
  );
}

const OperationWrapper = styled.div`
  display: flex;
`;
